import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import siteSlice from './apps/siteSlice';
import userSlice from './apps/userSlice';
import usersSlice from './apps/usersSlice';
import freeSpinSlice from './apps/freeSpinSlice';
import CustomizerReducer from './customizer/CustomizerSlice';
import groupInfoSlice from './apps/groupInfoSlice';
import financeSlice from './apps/financeSlice';
import infoSlice from './apps/infoSlice';
import gamesSlice from './apps/gamesInfoSlice';
import gameProvidersSlice from './apps/gameProvidersSlice';
import reportsSlice from './apps/reportsSlice';
import schedulerSlice from './apps/schedulerSlice';

/**
 * @typedef {ReturnType< typeof rootReducer >} RootState
 */

const rootReducer = combineReducers({
  site: siteSlice,
  user: userSlice,
  users: usersSlice,
  freeSpin: freeSpinSlice,
  groupInfo: groupInfoSlice,
  customizer: CustomizerReducer,
  finance: financeSlice,
  info: infoSlice,
  gameProviders: gameProvidersSlice,
  games: gamesSlice,
  reports: reportsSlice,
  scheduler: schedulerSlice
});

export const store = configureStore({ reducer: rootReducer });

/**
 * @type {import('react-redux').TypedUseSelectorHook<RootState>}
 */
export const useAppSelector = useSelector;
